import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  CardFooter,
} from '@/components/ui/card';
import { Heading } from '@/components/ui/shared/heading';
import { useTranslation } from 'react-i18next';

const PAYMENT_TYPES_WITHOUT_PRICE = new Set([
  'Kita',
  'Barteris',
  'Be sutarties',
  'Partneris',
]);

const isPsdfPayment = (paymentType) => {
  const type = paymentType?.toLowerCase() ?? '';
  return type.includes('vlk') || type.includes('psdf');
};

export const VisitPaymentServiceDetails = ({ service }) => {
  const { t } = useTranslation();

  const payments = (service?.payments ?? []).filter((payment) => {
    const paymentType = payment?.paymentType?.toLowerCase();
    return (
      paymentType === 'paysera' ||
      paymentType === 'kasa' ||
      isPsdfPayment(paymentType)
    );
  });

  if (!service || payments.length === 0) return null;

  return (
    <Card>
      {/* Same header styling as VisitPaymentVisitDetails */}
      <CardHeader>
        <Heading variant="userAccountDetailsTitle">
          {service.name} {/* ONLY title from service */}
        </Heading>
      </CardHeader>
      <CardContent className="space-y-3">
        {/* All details come from payments */}
        {payments.length > 0 && (
          <div className="space-y-4">
            {payments.map((p, idx) => (
              <div key={idx} className="space-y-1">
                {/* Price */}
                <div>
                  <span>{t('userAccount.visitTab.price')}</span>{' '}
                  <span>
                    {isPsdfPayment(p.paymentType) ||
                    PAYMENT_TYPES_WITHOUT_PRICE.has(p.paymentType)
                      ? '-'
                      : p.price?.toFixed(2)}
                  </span>
                </div>

                {/* Status */}
                <div>
                  <span>{t('userAccount.visitTab.state')}</span>{' '}
                  <span>
                    {isPsdfPayment(p.paymentType)
                      ? 'Apmokėta'
                      : p.status ?? 'Neapmokėta'}
                  </span>
                </div>

                {/* Payment Type */}
                <div>
                  <span>{t('userAccount.visitTab.payment')}</span>{' '}
                  <span>
                    {p.paymentType}
                    {!isPsdfPayment(p.paymentType) &&
                      !PAYMENT_TYPES_WITHOUT_PRICE.has(p.paymentType) &&
                      ` – ${p.price?.toFixed(2)}`}
                  </span>
                </div>
              </div>
            ))}
          </div>
        )}
      </CardContent>
      <CardFooter /> {/* SAME structure as VisitPaymentVisitDetails */}
    </Card>
  );
};
